<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="data"
                                :search="search"
                                :loading="loading"
                                :items-per-page="15"
                                :items-per-page-options="[15,30, 50, 100, -1]"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.name="{ item }">
                                <span>{{ item.fname }} {{ item.mname ? item.mname[0] + '.' : '' }} {{ item.lname }}{{ item.suffix ? ', ' + item.suffix : '' }}</span>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                    <v-btn @click="showViewDialog(item)" size="small" variant="outlined" text="View" color="green-accent-4" elevation="2"></v-btn>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

    <AccountVerificationDialog ref="AccountVerificationDialog" @refresh="init()"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import AccountVerificationDialog from '../Dialogs/AccountVerificationDialog.vue';

export default defineComponent({
    components: {
        AccountVerificationDialog
    },
    data(){
        return {
            data: [],
            search: null,
            loading: false,
            headers: [
                { title: 'Name', align: 'start', sortable: true, key: 'name' },
                { title: 'Office', align: 'start', sortable: true, key: 'office.abbrev' },
                { title: 'Program', align: 'start', sortable: true, key: 'program.abbrev' },
                { title: 'Position', align: 'start', sortable: true, key: 'position.name' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            schoolYearData: [],
            schoolyear_id: null,
            selectedSchoolyear: null,

            smAndDown: false
        }
    },
    methods: {
        async init(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/user-details/findAllUnverifiedAccounts',
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.data = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        showViewDialog(data){
            this.$refs.AccountVerificationDialog.init(data)
        },
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>